import type { DemoWatchlistSpec } from "@/pages/PortfolioBuilder/demoWatchlist";
import { getRecordedWatchlist } from "./fixtures";
import { recordedWatchlistSpec } from "./fixtures/fromRecording";
import { demoTemplateFor } from "./templates";
import type { AssetClassId } from "./types";

/**
 * The one watchlist a demo visitor gets for their asset class.
 *
 * Single source of truth for both places that install it — pickAssetClass, and the
 * gate's re-install after a reload. They each resolved it themselves before,
 * which is how they could disagree.
 *
 * The recording wins where there is one. The asset-class template's list and the
 * recorded plan's output are different watchlists with different names, and
 * the panels were being seeded with the template's while the builder showed
 * the recording's being built — so the step that says "apply that watchlist to
 * the feed" sent them to a menu that did not contain it. All five asset classes had
 * the mismatch.
 *
 * The template list stays as the fallback: an asset class with no recording still
 * needs something real in the panels, since /portfolios is 403 for this
 * audience and they would otherwise be empty.
 */
export function demoWatchlistFor(
  assetClass: AssetClassId
): DemoWatchlistSpec | null {
  const recorded = getRecordedWatchlist(assetClass);
  const fromRecording = recorded ? recordedWatchlistSpec(recorded) : null;
  if (fromRecording) return fromRecording;

  return demoTemplateFor(assetClass)?.watchlist ?? null;
}
